module.exports = __webpack_public_path__ + "img/service1.ef768009.png";